import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast-outlet',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="pointer-events-none fixed end-4 bottom-4 z-50 flex flex-col items-end gap-3"
    >
      @for (toast of toastService.messages(); track toast.id) {
        <div
          class="pointer-events-auto w-[calc(100vw_-_2rem)] max-w-[420px] overflow-hidden rounded-[14px] bg-white shadow-[0_8px_32px_rgba(0,0,0,0.14),0_2px_8px_rgba(0,0,0,0.08)] sm:w-auto sm:min-w-[320px]"
          [attr.role]="toast.type === 'error' ? 'alert' : 'status'"
          [attr.aria-live]="toast.type === 'error' ? 'assertive' : 'polite'"
        >
          <div
            class="flex items-center justify-between gap-3 px-5 py-4"
            [class.bg-[#FEF2F2]]="toast.type === 'error'"
            [class.text-[#B42318]]="toast.type === 'error'"
            [class.bg-[#ECFDF3]]="toast.type === 'success'"
            [class.text-[#027A48]]="toast.type === 'success'"
          >
            <div class="flex items-center gap-2.5">
              <div
                class="flex size-8 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white"
                [class.bg-[#B42318]]="toast.type === 'error'"
                [class.bg-[#027A48]]="toast.type === 'success'"
                aria-hidden="true"
              >
                {{ toast.type === 'success' ? '✓' : '×' }}
              </div>
              <p class="text-[15px] leading-tight font-bold">
                {{ toast.type === 'success' ? 'Success' : 'An Error Occurred' }}
              </p>
            </div>

            <button
              type="button"
              class="flex size-7 shrink-0 items-center justify-center rounded-full border text-xs font-bold transition-all hover:text-white"
              [class.border-[#B42318]]="toast.type === 'error'"
              [class.text-[#B42318]]="toast.type === 'error'"
              [class.hover:bg-[#B42318]]="toast.type === 'error'"
              [class.border-[#027A48]]="toast.type === 'success'"
              [class.text-[#027A48]]="toast.type === 'success'"
              [class.hover:bg-[#027A48]]="toast.type === 'success'"
              aria-label="Dismiss notification"
              (click)="toastService.dismiss(toast.id)"
            >
              ×
            </button>
          </div>

          <div class="px-5 py-4">
            <p class="break-words text-sm leading-relaxed text-neutral-600">
              {{ toast.message }}
            </p>
          </div>
        </div>
      }
    </div>
  `,
})
export class ToastOutlet {
  protected readonly toastService = inject(ToastService);
}
